import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";

import { AuthenticationService } from "../services/authentication.service";
import { environment } from "../../../environments/environment";
import { SessionTimeService } from "../services/session-time.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    public auth: AuthenticationService,
    protected sessionTimeService?: SessionTimeService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if ((this.auth.isLoggedIn() || this.auth.getToken() !== null) && request.url.includes(environment.backEndUrl)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.auth.getToken()}`,
        },
      });
    }
    return next.handle(request);
  }
}
